import { TYPE_TABULAR } from '@/lib/typography';

const NBSP = '\u00A0';

export function financeLocale(language: string): string {
  return language.startsWith('da') ? 'da-DK' : 'en-GB';
}

/** Amounts: "1.150 kr." / "DKK 1,150" with a non-breaking space. */
export function formatFinanceAmount(cents: number, language: string): string {
  const locale = financeLocale(language);
  const value = cents / 100;
  const formatted = value.toLocaleString(locale, {
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
  });
  return language.startsWith('da') ? `${formatted}${NBSP}kr.` : `DKK${NBSP}${formatted}`;
}

/** Short date in lists: "20. okt. 2026" / "20 Oct 2026". */
export function formatFinanceDate(iso: string | null | undefined, language: string): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(financeLocale(language), {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatFinanceMonth(now: Date, language: string): string {
  return now.toLocaleDateString(financeLocale(language), { month: 'long' });
}

export const FINANCE_NUM = TYPE_TABULAR;
